module.exports = __webpack_public_path__ + "ffa55e51ade62c7de14f901fbb87d24a.png";